import React, { useState } from 'react';
import { User } from '../../types';
import WorkflowList from './WorkflowList';
import WorkflowDesigner from './WorkflowDesigner';

interface WorkflowManagementProps {
  currentUser: User;
}

type ViewMode = 'list' | 'create' | 'edit' | 'view';

const WorkflowManagement: React.FC<WorkflowManagementProps> = ({ currentUser }) => {
  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [selectedWorkflowId, setSelectedWorkflowId] = useState<string | undefined>();

  const handleCreateWorkflow = () => {
    setSelectedWorkflowId(undefined);
    setViewMode('create');
  };

  const handleEditWorkflow = (workflowId: string) => {
    setSelectedWorkflowId(workflowId);
    setViewMode('edit');
  };

  const handleViewWorkflow = (workflowId: string) => {
    setSelectedWorkflowId(workflowId);
    setViewMode('view');
  };

  const handleBackToList = () => {
    setSelectedWorkflowId(undefined);
    setViewMode('list');
  };

  // 'view' has no dedicated read-only renderer (WorkflowDesigner is the only
  // screen that displays a workflow's states/transitions) — previously it fell
  // through to `else` below and re-rendered the plain list, so clicking a
  // workflow's "View" button silently did nothing. Route it through the
  // designer, same as 'edit', so the workflow's contents are actually shown.
  if (viewMode === 'create' || viewMode === 'edit' || viewMode === 'view') {
    return (
      <WorkflowDesigner
        currentUser={currentUser}
        workflowId={selectedWorkflowId}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <WorkflowList
      currentUser={currentUser}
      onCreateWorkflow={handleCreateWorkflow}
      onEditWorkflow={handleEditWorkflow}
      onViewWorkflow={handleViewWorkflow}
    />
  );
};

export default WorkflowManagement;
